'use client'

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import { FaBox, FaClock, FaUsers, FaBars, FaTimes } from "react-icons/fa";
import companyLogo from '../assets/gwh.png';
import aboutImage from '../assets/gwhouse.png';
import { useInView } from 'react-intersection-observer';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import slide1 from '../assets/slide1.jpg';
import slide2 from '../assets/slide2.png';
import slide3 from '../assets/slide3.jpg';
import FrontCard from '../assets/Frontcard.mp4'

import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";

const HomePage = () => {
  const [productCount, setProductCount] = useState(0);
  const [clientCount, setClientCount] = useState(0);
  const [yearsCount, setYearsCount] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [goToSlide, setGoToSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [slide1, slide2, slide3];

  useEffect(() => {
    const interval = setInterval(() => {
      setGoToSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    const animateCount = (setter, target, duration) => {
      let startTime;
      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        setter(Math.floor(progress * target));
        if (progress < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    };

    animateCount(setProductCount, 1952, 2000);
    animateCount(setClientCount, 100000, 2000);
    animateCount(setYearsCount, 100, 2000);
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const { ref: aboutRef, inView: aboutInView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const { ref: statsRef, inView: statsInView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <ParallaxProvider>
      <motion.div   
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="flex flex-col min-h-screen bg-[#E8F5E9]"
      >
        <header className="bg-white shadow-md p-4 flex justify-between items-center sticky top-0 z-50">
          <motion.img
            src={companyLogo}
            alt="Company Logo"
            className="h-16 cursor-pointer"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            whileHover={{ scale: 1.1 }}
            onClick={() => navigate("/")}
          />
          <div className="md:hidden">
            <motion.button
              onClick={handleMenuToggle}
              whileTap={{ scale: 0.9 }}
              className="text-3xl text-green-600"
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </motion.button>
          </div>
          <nav className={`absolute top-16 left-0 w-full bg-white md:static md:flex md:items-center md:justify-end md:space-x-6 text-sm md:text-lg shadow-md md:shadow-none ${isMenuOpen ? "flex flex-col items-center py-4 space-y-4" : "hidden"} md:flex`}>
            {["About", "Products", "Contact", "Export"].map((item, index) => (
              <motion.button
                key={index}
                onClick={() => {
                  navigate(`/${item.toLowerCase()}`);
                  setIsMenuOpen(false);
                }}
                className="font-semibold hover:text-green-600"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                {item}
              </motion.button>
            ))}
          </nav>
        </header>
      <section className="relative z-10"> {/* section above the video */}</section>

      <section className="w-full bg-white flex justify-center items-center px-4 py-6">
        <div className="w-full max-w-[1200px] aspect-video overflow-hidden rounded-xl shadow-lg border border-gray-200">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-contain"
          >
            <source src={FrontCard} type="video/mp4" loading="lazy" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>


        <section ref={aboutRef} className="container mx-auto p-2 mt-10 border-2 border-gray-300 rounded-lg shadow-lg bg-white">
          <motion.div
            className="flex flex-col md:flex-row items-center"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: aboutInView ? 1 : 0, y: aboutInView ? 0 : 50 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          >
            <div className="md:w-1/2 text-left p-6">
              <h2 className="text-3xl md:text-4xl font-bold">GowriHouse Metal Works LLP</h2>
              <p className="text-md md:text-lg leading-relaxed text-justify">
                Gowrihouse Metal Works LLP is a leading manufacturer, exporter and supplier of Wood Screws, Self-Tapping Screws and Mirror Screws in India. Gowrihouse Metal Works was established in the year 1952 by Shri P.A.C. Ramasamy Raja, Founder - Ramco Group of Industries - in South India with the objective to manufacture Mild Steel Wood screws and has a consistent record of catering to this segment to the complete satisfaction of the consumers.
                <br /><br />
                The unit has since added Drywall Screws, Concrete Nails, Self-Drilling Screws etc. to its manufacturing range. The unit at Rajapalayam is fully equipped with production machinery for the manufacture of these products and full-fledged laboratories are in operation for analysis of all the parameters.
              </p>
            </div>
            <motion.div
              className="md:w-1/2 flex justify-center mt-6 md:mt-0 p-6"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: aboutInView ? 1 : 0, scale: aboutInView ? 1 : 0.8 }}
              transition={{ duration: 1 }}
              whileHover={{ scale: 1.1 }}
            >
              <Parallax speed={10}>
                <img src={aboutImage} alt="Company Image" className="rounded-lg shadow-lg w-3/4 border-2 border-gray-400 p-2" />
              </Parallax>
            </motion.div>
          </motion.div>
        </section>

        <Parallax speed={-5}>
          <section className="my-10 py-12 bg-[#34C759] text-white text-center">
            <div className="container mx-auto flex flex-col md:flex-row justify-around gap-6">
              {[
                { icon: <FaClock />, count: productCount, label: "Since" },
                { icon: <FaBox />, count: yearsCount, label: "Product" },
                { icon: <FaUsers />, count: clientCount, label: "Clients" }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  className="flex flex-col items-center"
                  whileHover={{ scale: 1.1 }}
                  ref={statsRef}
                  animate={{ opacity: statsInView ? 1 : 0, y: statsInView ? 0 : 50 }}
                  transition={{ duration: 1.2, ease: "easeOut" }}
                >
                  <motion.div className="text-6xl" initial={{ rotate: 0 }} whileHover={{ rotate: 360 }}>
                    {item.icon}
                  </motion.div>
                  <h3 className="text-3xl md:text-4xl font-bold">
                    {item.label === "Since" ? item.count : `${item.count}+`}
                  </h3>
                  <p className="text-md md:text-lg">{item.label}</p>
                </motion.div>
              ))}
            </div>
          </section>
        </Parallax>
      </motion.div>
    </ParallaxProvider>
  );
};

export default HomePage;
